import { useCallback } from 'react';

import { useClientInformationStore } from '@src/store';
import useCollectionsDialogStore from '@src/store/modules/collections-dialog.store';

const useCollectionsGuard = () => {
	const openDialog = useCollectionsDialogStore((s) => s.openDialog);

	return useCallback(
		(e?: React.SyntheticEvent | Event) => {
			// read latest value (safe inside native listeners too)
			if (!useClientInformationStore.getState().isInCollections) return false;
			e?.preventDefault();
			e?.stopPropagation();
			openDialog();
			return true;
		},
		[openDialog]
	);
};

export default useCollectionsGuard;
